import { environment } from '../../../environments/environment';

export function resolveProfileImageUrl(value: unknown): string | undefined {
  if (value == null) {
    return undefined;
  }
  const path = String(value).trim();
  if (!path) {
    return undefined;
  }
  if (/^(https?:|blob:|data:)/i.test(path)) {
    return path;
  }

  const base = environment.wsUrl.replace(/\/$/, '');
  return `${base}/${path.replace(/^\//, '')}`;
}
